<table>
	<thead>
		<tr>
			<th class="subtable string" *ngFor="let header of tableHeaders" [ngClass]="{'string-longest': (header.des === 'NumeroIdentificacionFiscalProductor' || header.des === 'ProducerTaxIdentificationNumber') || (header.des === 'NumeroIdentificacionFiscal' || header.des === 'TaxIdentificationNumber' || header.des === 'producerMunicipality' || header.des === 'MunicipioProductor') }">{{header.des}}</th>
			<th class="subtable string">{{'csvLogs.error' | translate}}</th>
		</tr>
	</thead>
	<tbody *ngFor="let error of errors; let i = index">
		<tr>
			<!-- cultivos -->
			<ng-container *ngIf="mainKeyword === 'crops'">
				<td class="string">{{error.item.finca ?? error.item.farm}}</td>
				<td class="string">{{error.item.pais ?? error.item.country}}</td>
				<td class="string">{{error.item.provincia ?? error.item.province}}</td>
				<td class="string">{{error.item.municipio ?? error.item.municipality}}</td>
				<td class="string">{{error.item.denominacion ?? error.item.denomination}}</td>
				<td class="string">{{error.item.campana ?? error.item.season}}</td>
				<td class="string">{{error.item.superficie ?? error.item.surface}}</td>
				<td class="string">{{error.item.plantas ?? error.item.plants}}</td>
				<td class="string">{{error.item.aforo ?? error.item.capacity}}</td>
				<td class="string">{{error.item.productor ?? error.item.producer}}</td>
				<td class="string-longest">{{error.item.numeroIdentificacionFiscalProductor ?? error.item.producerTaxIdentificationNumber}}</td>
				<td class="string">{{error.item.licencias ?? error.item.licenses ?? error.item.licences}}</td>
			</ng-container>

			<!-- Productores -->
			<ng-container *ngIf="mainKeyword === 'producers'">
				<td class="string">{{error.item.nombre ?? error.item.name}}</td>
				<td class="string-longest">{{error.item.numeroIdentificacionFiscal ?? error.item.taxIdentificationNumber}}</td>
				<td class="string">{{error.item.paisProductor ?? error.item.producerCountry}}</td>
				<td class="string">{{error.item.provinciaProductor ?? error.item.producerProvince}}</td>
				<td class="string-longest">{{error.item.municipioProductor ?? error.item.producerMunicipality}}</td>
				<td class="string">{{error.item.pais ?? error.item.country}}</td>
				<td class="string">{{error.item.denominacion ?? error.item.denomination}}</td>
				<td class="string">{{error.item.direccion ?? error.item.address}}</td>
				<td class="string">{{error.item.personaContacto ?? error.item.contactPerson}}</td>
				<td class="string">{{error.item.telefono ?? error.item.phoneNumber}}</td>
			</ng-container>

			<!-- Columna fija para todos los tipos de CSV -->
			<td class="string">{{error.error}}</td>
		</tr>
	</tbody>
	<tfoot *ngIf="!errors || (errors && errors.length < 1)">
		<tr>
			<td [attr.colspan]="tableHeaders.length + 1">
				{{'global.noContent' | translate}}
			</td>
		</tr>
	</tfoot>
</table>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>